export const CERT_PREFIX = 'SIRT-ALG';

export const makeCertId = (index) => {
  const padded = String(index + 1).padStart(3, '0');
  return `${CERT_PREFIX}-${padded}`;
};

export const slugify = (value) => value
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9\s-]/g, '')
  .replace(/\s+/g, '-')
  .replace(/-+/g, '-');

export const encodeCertPayload = (payload) => {
  const json = JSON.stringify(payload);
  return btoa(encodeURIComponent(json));
};

export const decodeCertPayload = (encodedPayload) => {
  try {
    const json = decodeURIComponent(atob(encodedPayload));
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export const buildVerificationLink = (baseUrl, certId) => {
  const safeBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  return `${safeBase}/?certId=${encodeURIComponent(certId)}`;
};
